import React, { useEffect, useState } from 'react';
import { CloseRound } from 'res/images';
import { CoreSearchDropDown } from 'whealth-core-web/components';
import useApiManager from 'networking/ApiManager';
import { useParams } from 'react-router-dom';
import { profileImage, replaceWithRole, teamRoles } from 'whealth-core-web/components/Helper';
import { useDispatch, useSelector } from 'react-redux';
import { setAlerts, updatePatientDetailsApi } from 'redux/Slices';
import CommonToolTip from 'whealth-core-web/components/CommonToolTip';
import { useGetLoginUserDataQuery } from 'redux/apiSlice';

function AssignteamCard(props) {
  const { userData, inputValue, setInputValue, placeholder, searchRole, getPatientData, isNivanCare } = props;
  const ApiClient = useApiManager();
  const { id } = useParams();
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.sliceReducer.patientDetails.locations);
  const [data, setData] = useState([]);
  const [adminData, setAdminData] = useState([]);
  let loggedInUserData = useGetLoginUserDataQuery()?.data?.data || {};

  useEffect(() => {
    setAdminData(userData.admins);
  }, [userData]);

  const updatePatientDetails = () => {
    dispatch(updatePatientDetailsApi());
  };

  const searchAdminProfiles = () => {
    let qry = {
      role: searchRole || 'health_coach,health_coach_lead,admin,diet_health_coach,fitness_health_coach',
      search_str: inputValue,
      clinic: locations.toString(),
    };
    ApiClient.getSearchTeam(qry)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleItemClick = (item) => {
    setInputValue('');
    let data = { admin_id: item.id };
    ApiClient.assingAdmin(id, data)
      .then((res) => {
        setAdminData(res.data.admins);
        getPatientData();
        // updatePatientDetails();
      })
      .catch((err) => {
        let message = replaceWithRole(err.response?.data?.errors?.admins[0] || '');
        dispatch(setAlerts({ patient: { title: message, type: 'alert-danger' } }));
      });
    setData([]);
  };

  const removeUser = (itemId) => {
    let data = { admin_id: itemId };
    ApiClient.unasignAdmin(id, data)
      .then((res) => {
        setAdminData(res.data.admins);
        getPatientData();
        // updatePatientDetails();
      })
      .catch((err) => {
        if (!Array.isArray(Object.values(err.response.data)[0])) {
          dispatch(setAlerts({ patient: { title: Object.values(err.response.data)[0], type: 'alert-danger' } }));
        }
      });
  };

  const renderInputBox = () => {
    return (
      <>
        <CoreSearchDropDown
          setTimeOutData={searchAdminProfiles}
          {...props}
          inputValue={inputValue}
          inputStyle={{ height: '39px' }}
          data={data}
          setData={setData}
          setInputValue={setInputValue}
          placeholder={placeholder || ''}
          onClickItem={handleItemClick}
          dropDownStyle={{ left: '10px', right: '10px' }}
          isRightIconref
        />
        {inputValue.length > 2 && data.length == [] && (
          <div className='mt-2' style={{ textAlign: 'center' }}>
            No Data Found
          </div>
        )}
      </>
    );
  };

  const showUserDetails = () => {
    if (adminData?.length > 0) {
      return adminData.map((item) => {
        return (
          <div className='assignPatient'>
            <img className='rounded assignedPatientImage float-start img-fluid me-3' src={profileImage(item.gender, item.profile_url)} />
            <div className='font-10px'>
              <div className='capitalize bold'>{teamRoles(item.role)}</div>
              <div className='capitalize'>{item.full_name}</div>
            </div>
            {item?.role != 'doctor' && (
              <>
                {!loggedInUserData?.read_only && !['doctor', 'ee', 'ee_manager'].includes(loggedInUserData.role) && (
                  <div className='close-icon' onClick={() => removeUser(item.id)}>
                    <CommonToolTip placement={'top'} item={<img src={CloseRound} className='icon' />} showValue={'Remove'} />
                  </div>
                )}
              </>
            )}
          </div>
        );
      });
    }
  };

  return (
    <div className='d-md-flex mb-3'>
      <div className='card w-100 no-border'>
        <div className='card-body row'>{showUserDetails()}</div>
        <div className='linesView'>{!isNivanCare && <div className='assign-text-box m-2'>{renderInputBox()}</div>}</div>
      </div>
    </div>
  );
}

export default AssignteamCard;
